/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import CardImg from "../../assets/greens.png";
import FoodComponent from "../summary/food";
import TipsComponent from "../summary/tips";
import ResultsHeader from "../shared-ui/results-header";
import ToggleButton from "../shared-ui/toggle-button";
import CheckBox from "../shared-ui/checkbox";
import ProductComponent from "./product";
import DetailsComponent from "../details";
import Footer from "../shared-ui/footer";
import CartComponent from "../shared-ui/cart";
import { setAccessToken } from "../../services/commerceServices/accessToken";
import {
  addCartEntries,
  getCartEntries,
} from "../../services/commerceServices/cartServices";
import MessageStrip from "../shared-ui/message-strip";
import { formattedText } from "../../utils/formattedText";
import { validateOktaSession } from "../../utils/validateOktaSession";
import SaveResultsPopup from "../shared-ui/popup/save-results";
import {
  compareExpiryTime,
  compareGuestExpiryTime,
  setGuestExpiryTime,
} from "../../utils/handleExpiryTime";
import { withOktaAuth } from "@okta/okta-react";
import { clearSession } from "../../utils/clearSession";
import { handleGuestExpiryPopup } from "../../utils/handlePopups";
import { getSummaryInfo } from "../../utils/summaryInformation";
import _ from "lodash";
import { utag, withUtag } from "../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";
import PageNotFound from "../shared-ui/errors/page-not-found";
import { getNeedStatesInfo } from "../../utils/needStateInformation";

// Interface for SummaryComponent State
interface SummaryComponentState {
  isDetailsVisible: boolean;
  selectedType: string;
  needStatesTips: any;
  needStatesProducts: any;
  needStatesFoodsEat: any;
  needStatesFoodsAvoid: any;
  displayedData: any;
  displayedDataProducts: any;
  displayedDataFoodsEat: any;
  displayedDataFoodsAvoid: any;
  data: any;
  hitStateData: any;
  hitStateIndex: any;
  summaryType: any;
  productsToggle: any;
  foodsToggle: any;
  otherProducts: any;
  bestProducts: any;
  hitStateType: any;
  isCartVisible: boolean;
  quantity: number;
  successfullyAdded: boolean;
  hitStateHeading: any;
  isPopupOpen: boolean;
  hitStateSubType: any;
  productsInfo: any;
  tipsInfo: any;
  foodsInfo: any;
  isSessionExpired: boolean;
  isSaveResultPopupOpen: boolean;
  displayOutOfStock: boolean;
  visibleOnMobile: boolean;
  productFailedAddToCart: boolean;
}

/**
 * SummaryComponent component.
 *
 * @namespace SummaryComponent
 */
class SummaryComponent extends React.Component<any, SummaryComponentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isDetailsVisible: false,
      selectedType: "",
      needStatesTips: [],
      needStatesProducts: [],
      displayedData: [],
      needStatesFoodsEat: [],
      needStatesFoodsAvoid: [],
      displayedDataFoodsEat: [],
      displayedDataFoodsAvoid: [],
      data: [],
      hitStateData: [],
      hitStateIndex: [],
      summaryType: "",
      displayedDataProducts: [],
      productsToggle: "",
      otherProducts: [],
      bestProducts: [],
      hitStateType: "",
      isCartVisible: false,
      quantity: 1,
      successfullyAdded: false,
      hitStateHeading: "",
      isPopupOpen: false,
      foodsToggle: "",
      hitStateSubType: "",
      productsInfo: [],
      tipsInfo: [],
      foodsInfo: [],
      isSessionExpired: false,
      isSaveResultPopupOpen: false,
      displayOutOfStock: false,
      visibleOnMobile: false,
      productFailedAddToCart: false,
    };
  }

  handleSeeMore = (
    type: string,
    index?: number,
    subType?: string,
    heading?: string,
    e?: any
  ) => {
    if (type === "tips") {
      this.setState({
        hitStateData: this.state.displayedData,
        hitStateIndex: index,
        hitStateType: type,
        hitStateHeading: heading,
      });
    }

    if (type === "food" && subType === "eat") {
      this.setState({
        hitStateData: this.state.displayedDataFoodsEat,
        hitStateIndex: index,
        hitStateType: type,
        hitStateHeading: heading,
        hitStateSubType: subType,
      });
    }

    if (type === "food" && subType === "avoid") {
      this.setState({
        hitStateData: this.state.displayedDataFoodsAvoid,
        hitStateIndex: index,
        hitStateType: type,
        hitStateSubType: subType,
        hitStateHeading: heading,
      });
    }
    if (type === "product" && subType === "all") {
      this.setState({
        hitStateData: this.state.displayedDataProducts,
        hitStateIndex: index,
        hitStateType: type,
        hitStateSubType: subType,
      });
    }

    if (type === "product" && subType === "best") {
      this.setState({
        hitStateData: this.state.bestProducts,
        hitStateIndex: index,
        hitStateType: type,
        hitStateSubType: subType,
      });
    }

    if (type === "product" && subType === "other") {
      this.setState({
        hitStateData: this.state.otherProducts,
        hitStateIndex: index,
        hitStateType: type,
        hitStateSubType: subType,
      });
    }

    this.setState({
      isDetailsVisible: true,
      selectedType: type,
    });
  };
  handleDeatilsClose = () => {
    this.setState({
      isDetailsVisible: false,
    });
  };
  handleCheckboxClick = (evt: any, value: any) => {
    // if (evt && evt.charCode === 32) {
    //   return;
    // }
    if (
      this.props?.location?.state?.summaryType === "Tips" ||
      window.location.hash === "#tips"
    ) {
      const propsData =
        (this.props &&
          this.props.location &&
          this.props.location.state &&
          this.props.location.state.data.tips) ||
        localStorage.getObj("results")?.tips;

      const newData: any = [];

      const data = this.state.needStatesTips;

      const objIndex = data?.findIndex((obj: any) => obj?.name === value);
      data[objIndex].isChecked = evt?.target?.checked;
      this.setState({ needStatesTips: data });
      const filteredOptions = data?.filter(
        (obj: any) => obj?.isChecked === false
      ).length;
      if (filteredOptions === data?.length) {
        for (let index = 0; index < propsData?.length; index++) {
          propsData[index]?.tipsData &&
            newData.push(...propsData[index]?.tipsData);
        }
      } else {
        data?.forEach((element: any) => {
          if (element?.isChecked) {
            const index = propsData?.findIndex(
              (obj: any) => obj?.name === element?.name
            );
            propsData[index]?.tipsData &&
              newData.push(...propsData[index]?.tipsData);
          }
        });
      }
      this.setState({ displayedData: newData });
    }

    if (
      this.props.location?.state?.summaryType === "Products" ||
      window.location.hash === "#products"
    ) {
      const propsData =
        (this.props &&
          this.props.location &&
          this.props.location.state &&
          this.props.location.state.data.products) ||
        localStorage.getObj("results")?.products;

      const newData: any = [];
      const data = this.state?.needStatesProducts;
      const objIndex = data?.findIndex((obj: any) => obj?.name === value);
      data[objIndex].isChecked = evt?.target?.checked;
      this.setState({ needStatesProducts: data });
      const filteredOptions = data?.filter(
        (obj: any) => obj.isChecked === false
      ).length;
      // data?.products?.forEach((element: any) => {
      //   const products = element?.productsCompleteData;

      //   if (products && products?.length > 0) {
      //     const filteredProducts = _.filter(
      //       products,
      //       (item) => !_.isNil(item?.data)
      //     );
      //     filteredProducts &&
      //       filteredProducts.length > 0 &&
      //       displayedDataArray.push(...filteredProducts);
      //   }
      // });
      if (filteredOptions === data?.length) {
        for (let index = 0; index < propsData?.length; index++) {
          let products = propsData[index]?.productsCompleteData;
          if (products && products?.length > 0) {
            const filteredProducts = _.filter(
              products,
              (item) => !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
            );
            filteredProducts &&
              filteredProducts.length > 0 &&
              newData?.push(...filteredProducts);
          }
          // propsData[index]?.productsCompleteData &&
          //   newData?.push(...propsData[index]?.productsCompleteData);
        }
      } else {
        data.forEach((element: any) => {
          if (element.isChecked) {
            const index = propsData?.findIndex(
              (obj: any) => obj?.name === element?.name
            );
            let products = propsData[index]?.productsCompleteData;
            if (products && products?.length > 0) {
              const filteredProducts = _.filter(
                products,
                (item) =>
                  !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
              );
              filteredProducts &&
                filteredProducts.length > 0 &&
                newData?.push(...filteredProducts);
            }

            // propsData[index]?.productsCompleteData &&
            //   newData?.push(...propsData[index]?.productsCompleteData);
          }
        });
      }

      this.setState({ displayedDataProducts: newData }, () => {
        let bestIds: any = [];

        const prods = this.state.data.products;

        prods?.forEach((element: any) => {
          bestIds.push(element.products[0]);
        });

        let resultBest = this.state?.displayedDataProducts?.filter(
          (element: any) => {
            return bestIds?.indexOf(element?.data?.code) !== -1;
          }
        );

        this.setState({ bestProducts: resultBest });
        let resultOther = this.state?.displayedDataProducts?.filter(
          (element: any) => {
            return bestIds?.indexOf(element?.data?.code) === -1;
          }
        );

        this.setState({ otherProducts: resultOther });
      });
    }

    if (
      this.props?.location?.state?.summaryType === "Foods" ||
      window.location.hash === "#foods"
    ) {
      const propsData =
        (this.props &&
          this.props.location &&
          this.props.location.state &&
          this.props.location.state.data.foods) ||
        localStorage.getObj("results")?.foods;

      const newData: any = [];
      const newData2: any = [];

      const data = this.state.needStatesFoodsEat;

      const objIndex = data?.findIndex((obj: any) => obj?.name === value);
      if (objIndex > -1) {
        data[objIndex].isChecked = evt?.target?.checked;
      }
      this.setState({ needStatesFoodsEat: data });

      const data2 = this.state.needStatesFoodsAvoid;

      const objIndex2 = data2?.findIndex((obj: any) => obj?.name === value);
      if (objIndex2 > -1) {
        data2[objIndex2].isChecked = evt?.target?.checked;
      }
      this.setState({ needStatesFoodsAvoid: data2 });
      const filteredOptions = data?.filter(
        (obj: any) => obj?.isChecked === false
      ).length;
      if (filteredOptions === data?.length) {
        for (let index = 0; index < propsData?.length; index++) {
          propsData[index]?.foodsCompleteData?.foodsEat &&
            newData.push(...propsData[index]?.foodsCompleteData?.foodsEat);
        }
      } else {
        data?.forEach((element: any) => {
          if (element?.isChecked) {
            const index = propsData?.findIndex(
              (obj: any) => obj?.name === element?.name
            );
            propsData[index]?.foodsCompleteData?.foodsEat &&
              newData.push(...propsData[index]?.foodsCompleteData?.foodsEat);
          }
        });
      }
      this.setState({ displayedDataFoodsEat: newData });

      const filteredOptions2 = data2?.filter(
        (obj: any) => obj?.isChecked === false
      ).length;
      if (filteredOptions2 === data2?.length) {
        for (let index = 0; index < propsData?.length; index++) {
          propsData[index]?.foodsCompleteData?.foodsAvoid &&
            newData2.push(...propsData[index]?.foodsCompleteData?.foodsAvoid);
        }
      } else {
        data2?.forEach((element: any) => {
          if (element?.isChecked) {
            const index = propsData?.findIndex(
              (obj: any) => obj?.name === element?.name
            );
            propsData[index]?.foodsCompleteData?.foodsAvoid &&
              newData2.push(...propsData[index]?.foodsCompleteData?.foodsAvoid);
          }
        });
      }
      this.setState({ displayedDataFoodsAvoid: newData2 });
    }
  };

  hitStateClose = () => {
    this.setState({ isDetailsVisible: false });
  };

  componentDidMount = () => {
    // const getNeedStateData: any = getNeedStatesInfo("ms_result_landing_page");

    // getNeedStateData?.then((response: any) => {
    //   sessionStorage.setObj("results-info", response);
    // });

    // if (this.props?.location?.state?.summaryType === "Products") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Products",
    //     page_category: "wellness-products",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );
    //   withUtag().then((utag) => utag.view(updatedObj));
    // } else if (this.props?.location?.state?.summaryType === "Foods") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Foods",
    //     page_category: "wellness-foods",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );

    //   withUtag().then((utag) => utag.view(updatedObj));
    // } else if (this.props?.location?.state?.summaryType === "Tips") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Tips",
    //     page_category: "wellness-tips",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );
    //   withUtag().then((utag) => utag.view(updatedObj));
    // }

    let self = this;
    window.addEventListener("popstate", function (event) {
      self.hitStateClose();
    });

    const mediaQuery = window.matchMedia("(max-width: 767px)").matches;
    if (mediaQuery) {
      this.setState({
        visibleOnMobile: true,
      });
    }
    // setAccessToken();

    //handle guest expiry popup
    handleGuestExpiryPopup(this.props);

    //handle save result popup
    let saveResultPopupTime: any;
    if (
      compareExpiryTime() > 0 &&
      !localStorage.getItem("okta-token-storage")
    ) {
      saveResultPopupTime = setTimeout(() => {
        this.setState({
          isPopupOpen: true,
          isSaveResultPopupOpen: true,
        });
      }, compareExpiryTime() * 1000);
    }

    //clear the timeouts set when user get logged in
    if (localStorage.getItem("okta-token-storage")) {
      sessionStorage.removeItem("guestSaveResultTime");
      clearTimeout(saveResultPopupTime);
    }
    const getSummaryData: any = getSummaryInfo("ms_summary_page");
    getSummaryData?.then((response: any) => {
      this.setState({
        productsInfo: response?.products || [],
        tipsInfo: response?.tips || [],
        foodsInfo: response?.foods || [],
      });
    });
    if (localStorage.getObj("results")) {
      if (this.props.location?.state?.summaryType) {
        if (
          this.state?.summaryType !== this.props.location?.state?.summaryType
        ) {
          this.setState({
            data: this.props?.location?.state?.data,
            summaryType: this.props?.location?.state?.summaryType,
          });
          const data =
            this.props &&
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.data;

          let needStateData: any =
            (localStorage.getItem("results-info") !== "undefined" &&
              localStorage.getObj("results-info")?.need_state) ||
            {};
          if (!_.isEmpty(data) && !_.isEmpty(needStateData)) {
            const transform = (x: any) => x.replaceAll("_", "-");
            needStateData &&
              !_.isEmpty(needStateData) &&
              Object?.keys(needStateData)?.forEach((key) => {
                const val = needStateData[key];
                delete needStateData[key];
                needStateData[transform(key)] = val;
              });

            if (this.props?.location?.state?.summaryType === "Tips") {
              //if summaryType is Tips

              // window.history.pushState(
              //   null,
              //   "",
              //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
              // );
              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Tips",
                page_category: "wellness-tips",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );
              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];
              data?.tips?.forEach((element: any) => {
                if (element?.tipsData && element?.tipsData.length > 0) {
                  filter?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   element?.tipsData?.length +
                    //   ")",
                    name: element?.name || "",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.tipsData?.length +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });

              this.setState({ needStatesTips: filter });
              let displayedDataArray: any = [];
              data?.tips?.forEach((element: any) => {
                const tips = element?.tipsData;
                tips && displayedDataArray?.push(...tips);
              });

              this.setState({ displayedData: displayedDataArray });
            }

            if (this.props?.location?.state?.summaryType === "Foods") {
              //if summaryType is Foods

              // window.history.pushState(
              //   null,
              //   "",
              //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
              // );
              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Foods",
                page_category: "wellness-foods",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );

              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];
              data?.foods?.forEach((element: any) => {
                if (element?.foodsCompleteData?.foodsEat?.length > 0) {
                  filter?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    //element?.foodsCompleteData?.foodsEat?.length

                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.foodsCompleteData?.foodsEat?.length +
                      ")" || "",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   element?.foodsCompleteData?.foodsEat?.length +
                    //   ")",
                    name: element?.name || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });
              // this.setState({ needStatesFoodsEat: filter });
              let displayedDataFoodsEat: any = [];
              data?.foods?.forEach((element: any) => {
                const foods = element?.foodsCompleteData?.foodsEat;
                foods && displayedDataFoodsEat?.push(...foods);
              });

              //this.setState({ displayedDataFoodsEat: displayedDataFoodsEat });

              let filterAvoid: any = [];
              data?.foods?.forEach((element: any) => {
                if (element?.foodsCompleteData?.foodsAvoid?.length > 0) {
                  filterAvoid?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   element?.foodsCompleteData?.foodsAvoid?.length +
                    //   ")",
                    name: element?.name || "",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.foodsCompleteData?.foodsAvoid?.length +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });
              //this.setState({ needStatesFoodsAvoid: filterAvoid });
              let displayedDataFoodsAvoid: any = [];
              data?.foods?.forEach((element: any) => {
                const foods = element?.foodsCompleteData?.foodsAvoid;
                foods && displayedDataFoodsAvoid?.push(...foods);
              });

              this.setState(
                {
                  displayedDataFoodsAvoid: displayedDataFoodsAvoid,
                  displayedDataFoodsEat: displayedDataFoodsEat,
                  needStatesFoodsAvoid: filterAvoid,
                  needStatesFoodsEat: filter,
                },
                () => {
                  this.setState({ foodsToggle: "eat" });
                }
              );
            }

            if (this.props.location?.state?.summaryType === "Products") {
              //if summaryType is Products

              // window.history.pushState(
              //   null,
              //   "",
              //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
              // );

              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Products",
                page_category: "wellness-products",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );
              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];

              data?.products?.forEach((element: any) => {
                if (
                  element?.productsCompleteData &&
                  _.size(
                    _.filter(
                      element?.productsCompleteData,
                      (item) =>
                        !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                    )
                  ) > 0
                ) {
                  filter?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   +_.size(
                    //     _.filter(
                    //       element?.productsCompleteData,
                    //       (item) => !_.isNil(item?.data)
                    //     )
                    //   ) +
                    //   ")",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      +_.size(
                        _.filter(
                          element?.productsCompleteData,
                          (item) =>
                            !_.isNil(item?.data) &&
                            item?.data?.name !== "NOT FOUND"
                        )
                      ) +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    name: element?.name || "",
                    isChecked: false,
                  });
                }
              });
              this.setState({ needStatesProducts: filter });
              let displayedDataArray: any = [];
              data?.products?.forEach((element: any) => {
                const products = element?.productsCompleteData;

                if (products && products?.length > 0) {
                  const filteredProducts = _.filter(
                    products,
                    (item) =>
                      !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                  );

                  filteredProducts &&
                    filteredProducts.length > 0 &&
                    displayedDataArray.push(...filteredProducts);
                }
              });

              this.setState(
                { displayedDataProducts: displayedDataArray },
                () => {
                  this.setState({ productsToggle: "on" });
                  let bestIds: any = [];
                  const prods = this.state.data.products;

                  prods?.forEach((element: any) => {
                    bestIds.push(element.products[0]);
                  });

                  let resultBest = this.state?.displayedDataProducts?.filter(
                    (element: any) => {
                      return bestIds?.indexOf(element?.data?.code) !== -1;
                    }
                  );

                  this.setState({ bestProducts: resultBest });
                  let resultOther = this.state?.displayedDataProducts?.filter(
                    (element: any) => {
                      return bestIds?.indexOf(element?.data?.code) === -1;
                    }
                  );

                  this.setState({ otherProducts: resultOther });
                }
              );
            }
          }
        }
      } else {
        if (window.location.pathname === "/summary/") {
          let hashValue = window.location.hash;
          let formattedSummaryType = _.capitalize(
            hashValue.replaceAll("#", "")
          );

          if (this.state?.summaryType !== formattedSummaryType) {
            this.setState({
              summaryType: formattedSummaryType,
              data: localStorage.getObj("results"),
            });
            let data: any = localStorage.getObj("results");
            // const data =
            //   this.props &&
            //   this.props.location &&
            //   this.props.location.state &&
            //   this.props.location.state.data;
            let needStateData: any =
              (localStorage.getItem("results-info") !== "undefined" &&
                localStorage.getObj("results-info")?.need_state) ||
              {};
            if (!_.isEmpty(data) && !_.isEmpty(needStateData)) {
              const transform = (x: any) => x.replaceAll("_", "-");
              needStateData &&
                !_.isEmpty(needStateData) &&
                Object?.keys(needStateData)?.forEach((key) => {
                  const val = needStateData[key];
                  delete needStateData[key];
                  needStateData[transform(key)] = val;
                });

              if (formattedSummaryType === "Tips") {
                //if summaryType is Tips

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );
                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Tips",
                  page_category: "wellness-tips",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.tips?.forEach((element: any) => {
                  if (element?.tipsData && element?.tipsData.length > 0) {
                    filter.push({
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   element?.tipsData?.length +
                      //   ")",
                      name: element?.name || "",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.tipsData?.length +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                this.setState({ needStatesTips: filter });
                let displayedData: any = [];
                data?.tips?.forEach((element: any) => {
                  const tips = element.tipsData;
                  tips && displayedData.push(...tips);
                });

                this.setState({ displayedData: displayedData });
              }

              if (formattedSummaryType === "Foods") {
                //if summaryType is Foods

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );
                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Foods",
                  page_category: "wellness-foods",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.foods?.forEach((element: any) => {
                  if (element?.foodsCompleteData?.foodsEat?.length > 0) {
                    filter?.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      //element?.foodsCompleteData?.foodsEat?.length
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.foodsCompleteData?.foodsEat?.length +
                        ")" || "",
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   element?.foodsCompleteData?.foodsEat?.length +
                      //   ")",
                      name: element?.name || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                // this.setState({ needStatesFoodsEat: filter });
                let displayedDataFoodsEat: any = [];
                data?.foods?.forEach((element: any) => {
                  const foods = element?.foodsCompleteData?.foodsEat;
                  foods && displayedDataFoodsEat?.push(...foods);
                });

                //this.setState({ displayedDataFoodsEat: displayedDataFoodsEat });

                let filterAvoid: any = [];
                data?.foods?.forEach((element: any) => {
                  if (element?.foodsCompleteData?.foodsAvoid?.length > 0) {
                    filterAvoid?.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      name: element?.name || "",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.foodsCompleteData?.foodsAvoid?.length +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                //this.setState({ needStatesFoodsAvoid: filterAvoid });
                let displayedDataFoodsAvoid: any = [];
                data?.foods?.forEach((element: any) => {
                  const foods = element?.foodsCompleteData?.foodsAvoid;
                  foods && displayedDataFoodsAvoid?.push(...foods);
                });

                this.setState(
                  {
                    displayedDataFoodsAvoid: displayedDataFoodsAvoid,
                    displayedDataFoodsEat: displayedDataFoodsEat,
                    needStatesFoodsAvoid: filterAvoid,
                    needStatesFoodsEat: filter,
                  },
                  () => {
                    this.setState({ foodsToggle: "eat" });
                  }
                );
              }

              if (formattedSummaryType === "Products") {
                //if summaryType is Products

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );

                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Products",
                  page_category: "wellness-products",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.products?.forEach((element: any) => {
                  if (
                    element?.productsCompleteData &&
                    _.size(
                      _.filter(
                        element?.productsCompleteData,
                        (item) =>
                          !_.isNil(item?.data) &&
                          item?.data?.name !== "NOT FOUND"
                      )
                    ) > 0
                  ) {
                    filter.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        +_.size(
                          _.filter(
                            element?.productsCompleteData,
                            (item) =>
                              !_.isNil(item?.data) &&
                              item?.data?.name !== "NOT FOUND"
                          )
                        ) +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   +_.size(
                      //     _.filter(
                      //       element?.productsCompleteData,
                      //       (item) => !_.isNil(item?.data)
                      //     )
                      //   ) +
                      //   ")",
                      name: element?.name || "",
                      isChecked: false,
                    });
                  }
                });
                this.setState({ needStatesProducts: filter });
                let displayedDataArray: any = [];
                data?.products?.forEach((element: any) => {
                  // const products = element?.productsCompleteData;
                  // products && displayedDataArray?.push(...products);
                  const products = element?.productsCompleteData;

                  if (products && products?.length > 0) {
                    const filteredProducts = _.filter(
                      products,
                      (item) =>
                        !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                    );
                    filteredProducts &&
                      filteredProducts.length > 0 &&
                      displayedDataArray.push(...filteredProducts);
                  }
                });

                this.setState(
                  { displayedDataProducts: displayedDataArray },
                  () => {
                    this.setState({ productsToggle: "on" });
                    let bestIds: any = [];
                    const prods = this.state.data.products;

                    prods?.forEach((element: any) => {
                      bestIds.push(element?.products[0]);
                    });

                    let resultBest = this.state.displayedDataProducts?.filter(
                      (element: any) => {
                        return bestIds?.indexOf(element?.data?.code) !== -1;
                      }
                    );

                    this.setState({ bestProducts: resultBest });
                    let resultOther = this.state.displayedDataProducts?.filter(
                      (element: any) => {
                        return bestIds?.indexOf(element?.data?.code) === -1;
                      }
                    );

                    this.setState({ otherProducts: resultOther });
                  }
                );
              }
            }
          }
        }
      }
    } else {
      this.props.history.push("/results");
    }
  };
  // componentWillReceiveProps(props: any) {
  //   if (this.props?.location?.state?.summaryType === "Products") {
  //     let authObj = getUtagAuthObject();
  //     let sessionObj = getUtagSessionObject();
  //     let needStatesObj = getUtagNeedStates();

  //     let obj = {
  //       page_name: "My Products",
  //       page_category: "wellness-products",
  //     };
  //     let updatedObj = _.merge(
  //       localStorage.getItem("user-info") ? authObj : {},
  //       localStorage.getObj("reco-result") ? needStatesObj : {},
  //       sessionObj,
  //       obj
  //     );
  //     withUtag().then((utag) => utag.view(updatedObj));
  //   } else if (props?.location?.state?.summaryType === "Foods") {
  //     let authObj = getUtagAuthObject();
  //     let sessionObj = getUtagSessionObject();
  //     let needStatesObj = getUtagNeedStates();

  //     let obj = {
  //       page_name: "My Foods",
  //       page_category: "wellness-foods",
  //     };
  //     let updatedObj = _.merge(
  //       localStorage.getItem("user-info") ? authObj : {},
  //       localStorage.getObj("reco-result") ? needStatesObj : {},
  //       sessionObj,
  //       obj
  //     );
  //     withUtag().then((utag) => utag.view(updatedObj));
  //   } else if (props?.location?.state?.summaryType === "Tips") {
  //     let authObj = getUtagAuthObject();
  //     let sessionObj = getUtagSessionObject();
  //     let needStatesObj = getUtagNeedStates();

  //     let obj = {
  //       page_name: "My Tips",
  //       page_category: "wellness-tips",
  //     };
  //     let updatedObj = _.merge(
  //       localStorage.getItem("user-info") ? authObj : {},
  //       localStorage.getObj("reco-result") ? needStatesObj : {},
  //       sessionObj,
  //       obj
  //     );
  //     withUtag().then((utag) => utag.view(updatedObj));
  //   }
  // }
  componentDidUpdate = () => {
    // window.history.pushState(
    //   null,
    //   "",
    //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
    // );
    // if (this.props?.location?.state?.summaryType === "Products") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Products",
    //     page_category: "wellness-products",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );
    //   withUtag().then((utag) => utag.view(updatedObj));
    // } else if (this.props?.location?.state?.summaryType === "Foods") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Foods",
    //     page_category: "wellness-foods",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );
    //   withUtag().then((utag) => utag.view(updatedObj));
    // } else if (this.props?.location?.state?.summaryType === "Tips") {
    //   let authObj = getUtagAuthObject();
    //   let sessionObj = getUtagSessionObject();
    //   let needStatesObj = getUtagNeedStates();

    //   let obj = {
    //     page_name: "My Tips",
    //     page_category: "wellness-tips",
    //   };
    //   let updatedObj = _.merge(
    //     localStorage.getItem("user-info") ? authObj : {},
    //     localStorage.getObj("reco-result") ? needStatesObj : {},
    //     sessionObj,
    //     obj
    //   );
    //   withUtag().then((utag) => utag.view(updatedObj));
    // }

    validateOktaSession(this.props.oktaAuth);
    if (
      !localStorage.getItem("reco-result") &&
      !localStorage.getItem("user-response")
    ) {
      sessionStorage.setItem("foundationalPageCount", JSON.stringify(0));
      this.props.history.push("/foundational");
    }
    if (
      localStorage.getItem("guestExpiryTime") &&
      compareGuestExpiryTime() < 0
    ) {
      clearSession(this.props);
    }

    //enables login session expiry popup
    if (
      sessionStorage.getItem("login-session-expired") &&
      !this.state.isSessionExpired &&
      !(localStorage?.getItem("okta-token-storage") !== "{}")
    ) {
      this.setState({
        isSessionExpired: true,
        isPopupOpen: true,
      });
    }

    if (localStorage.getObj("results")) {
      if (this.props.location?.state?.summaryType) {
        if (
          this.state?.summaryType !== this.props?.location?.state?.summaryType
        ) {
          this.setState({
            summaryType: this.props?.location?.state?.summaryType,
            data: localStorage.getObj("results"),
          });
          const data =
            this.props &&
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.data;
          let needStateData: any =
            (localStorage.getItem("results-info") !== "undefined" &&
              localStorage.getObj("results-info")?.need_state) ||
            {};

          if (!_.isEmpty(data) && !_.isEmpty(needStateData)) {
            const transform = (x: any) => x.replaceAll("_", "-");
            needStateData &&
              !_.isEmpty(needStateData) &&
              Object?.keys(needStateData)?.forEach((key) => {
                const val = needStateData[key];
                delete needStateData[key];
                needStateData[transform(key)] = val;
              });

            if (this.props?.location?.state?.summaryType === "Tips") {
              //if summaryType is Tips

              // window.history.pushState(
              //   null,
              //   "",
              //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
              // );
              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Tips",
                page_category: "wellness-tips",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );
              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];
              data?.tips?.forEach((element: any) => {
                if (element?.tipsData && element?.tipsData.length > 0) {
                  filter.push({
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   element?.tipsData?.length +
                    //   ")",
                    name: element?.name || "",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.tipsData?.length +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });
              this.setState({ needStatesTips: filter });
              let displayedData: any = [];
              data?.tips?.forEach((element: any) => {
                const tips = element.tipsData;
                tips && displayedData.push(...tips);
              });

              this.setState({ displayedData: displayedData });
            }

            if (this.props?.location?.state?.summaryType === "Foods") {
              //if summaryType is Foods

              // window.history.pushState(
              //   null,
              //   "",
              //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
              // );
              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Foods",
                page_category: "wellness-foods",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );
              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];
              data?.foods?.forEach((element: any) => {
                if (element?.foodsCompleteData?.foodsEat?.length > 0) {
                  filter?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    //element?.foodsCompleteData?.foodsEat?.length
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.foodsCompleteData?.foodsEat?.length +
                      ")" || "",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   element?.foodsCompleteData?.foodsEat?.length +
                    //   ")",
                    name: element?.name || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });
              // this.setState({ needStatesFoodsEat: filter });
              let displayedDataFoodsEat: any = [];
              data?.foods?.forEach((element: any) => {
                const foods = element?.foodsCompleteData?.foodsEat;
                foods && displayedDataFoodsEat?.push(...foods);
              });

              //this.setState({ displayedDataFoodsEat: displayedDataFoodsEat });

              let filterAvoid: any = [];
              data?.foods?.forEach((element: any) => {
                if (element?.foodsCompleteData?.foodsAvoid?.length > 0) {
                  filterAvoid?.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    name: element?.name || "",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      element?.foodsCompleteData?.foodsAvoid?.length +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    isChecked: false,
                  });
                }
              });
              //this.setState({ needStatesFoodsAvoid: filterAvoid });
              let displayedDataFoodsAvoid: any = [];
              data?.foods?.forEach((element: any) => {
                const foods = element?.foodsCompleteData?.foodsAvoid;
                foods && displayedDataFoodsAvoid?.push(...foods);
              });

              this.setState(
                {
                  displayedDataFoodsAvoid: displayedDataFoodsAvoid,
                  displayedDataFoodsEat: displayedDataFoodsEat,
                  needStatesFoodsAvoid: filterAvoid,
                  needStatesFoodsEat: filter,
                },
                () => {
                  this.setState({ foodsToggle: "eat" });
                }
              );
            }

            if (this.props.location.state.summaryType === "Products") {
              //if summaryType is Products

              let authObj = getUtagAuthObject();
              let sessionObj = getUtagSessionObject();
              let needStatesObj = getUtagNeedStates();

              let obj = {
                page_name: "My Products",
                page_category: "wellness-products",
              };
              let updatedObj = _.merge(
                localStorage.getItem("user-info") ? authObj : {},
                localStorage.getObj("reco-result") ? needStatesObj : {},
                sessionObj,
                obj
              );
              withUtag().then((utag) => utag.view(updatedObj));
              let filter: any = [];
              data?.products?.forEach((element: any) => {
                if (
                  element?.productsCompleteData &&
                  _.size(
                    _.filter(
                      element?.productsCompleteData,
                      (item) =>
                        !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                    )
                  ) > 0
                ) {
                  filter.push({
                    //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                    displayName:
                      needStateData[element?.name]?.[0] +
                      " (" +
                      +_.size(
                        _.filter(
                          element?.productsCompleteData,
                          (item) =>
                            !_.isNil(item?.data) &&
                            item?.data?.name !== "NOT FOUND"
                        )
                      ) +
                      ")" || "",
                    imgSrc: needStateData[element?.name]?.[3] || "",
                    // displayName:
                    //   formattedText(element?.name) +
                    //   " (" +
                    //   +_.size(
                    //     _.filter(
                    //       element?.productsCompleteData,
                    //       (item) => !_.isNil(item?.data)
                    //     )
                    //   ) +
                    //   ")",
                    name: element?.name || "",
                    isChecked: false,
                  });
                }
              });
              this.setState({ needStatesProducts: filter });
              let displayedDataArray: any = [];
              data?.products?.forEach((element: any) => {
                // const products = element?.productsCompleteData;
                // products && displayedDataArray?.push(...products);
                const products = element?.productsCompleteData;

                if (products && products?.length > 0) {
                  const filteredProducts = _.filter(
                    products,
                    (item) =>
                      !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                  );
                  filteredProducts &&
                    filteredProducts.length > 0 &&
                    displayedDataArray.push(...filteredProducts);
                }
              });

              this.setState(
                { displayedDataProducts: displayedDataArray },
                () => {
                  this.setState({ productsToggle: "on" });
                  let bestIds: any = [];
                  const prods = this.state.data.products;

                  prods.forEach((element: any) => {
                    bestIds.push(element?.products[0]);
                  });

                  let resultBest = this.state.displayedDataProducts?.filter(
                    (element: any) => {
                      return bestIds?.indexOf(element?.data?.code) !== -1;
                    }
                  );

                  this.setState({ bestProducts: resultBest });
                  let resultOther = this.state.displayedDataProducts?.filter(
                    (element: any) => {
                      return bestIds?.indexOf(element?.data?.code) === -1;
                    }
                  );

                  this.setState({ otherProducts: resultOther });
                }
              );
            }
          }
        }
      } else {
        if (window.location.pathname === "/summary/") {
          let hashValue = window.location.hash;
          let formattedSummaryType = _.capitalize(
            hashValue.replaceAll("#", "")
          );

          if (this.state?.summaryType !== formattedSummaryType) {
            this.setState({
              summaryType: formattedSummaryType,
              data: localStorage.getObj("results"),
            });
            let data: any = localStorage.getObj("results");
            // const data =
            //   this.props &&
            //   this.props.location &&
            //   this.props.location.state &&
            //   this.props.location.state.data;
            let needStateData: any =
              (localStorage.getItem("results-info") !== "undefined" &&
                localStorage.getObj("results-info")?.need_state) ||
              {};

            if (!_.isEmpty(data) && !_.isEmpty(needStateData)) {
              const transform = (x: any) => x.replaceAll("_", "-");
              needStateData &&
                !_.isEmpty(needStateData) &&
                Object?.keys(needStateData)?.forEach((key) => {
                  const val = needStateData[key];
                  delete needStateData[key];
                  needStateData[transform(key)] = val;
                });

              if (formattedSummaryType === "Tips") {
                //if summaryType is Tips

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );
                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Tips",
                  page_category: "wellness-tips",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.tips?.forEach((element: any) => {
                  if (element?.tipsData && element?.tipsData.length > 0) {
                    filter.push({
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   element?.tipsData?.length +
                      //   ")",
                      name: element?.name || "",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.tipsData?.length +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                this.setState({ needStatesTips: filter });
                let displayedData: any = [];
                data?.tips?.forEach((element: any) => {
                  const tips = element.tipsData;
                  tips && displayedData.push(...tips);
                });

                this.setState({ displayedData: displayedData });
              }

              if (formattedSummaryType === "Foods") {
                //if summaryType is Foods

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );
                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Foods",
                  page_category: "wellness-foods",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.foods?.forEach((element: any) => {
                  if (element?.foodsCompleteData?.foodsEat?.length > 0) {
                    filter?.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      //element?.foodsCompleteData?.foodsEat?.length
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.foodsCompleteData?.foodsEat?.length +
                        ")" || "",
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   element?.foodsCompleteData?.foodsEat?.length +
                      //   ")",
                      name: element?.name || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                // this.setState({ needStatesFoodsEat: filter });
                let displayedDataFoodsEat: any = [];
                data?.foods?.forEach((element: any) => {
                  const foods = element?.foodsCompleteData?.foodsEat;
                  foods && displayedDataFoodsEat?.push(...foods);
                });

                //this.setState({ displayedDataFoodsEat: displayedDataFoodsEat });

                let filterAvoid: any = [];
                data?.foods?.forEach((element: any) => {
                  if (element?.foodsCompleteData?.foodsAvoid?.length > 0) {
                    filterAvoid?.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      name: element?.name || "",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        element?.foodsCompleteData?.foodsAvoid?.length +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      isChecked: false,
                    });
                  }
                });
                //this.setState({ needStatesFoodsAvoid: filterAvoid });
                let displayedDataFoodsAvoid: any = [];
                data?.foods?.forEach((element: any) => {
                  const foods = element?.foodsCompleteData?.foodsAvoid;
                  foods && displayedDataFoodsAvoid?.push(...foods);
                });

                this.setState(
                  {
                    displayedDataFoodsAvoid: displayedDataFoodsAvoid,
                    displayedDataFoodsEat: displayedDataFoodsEat,
                    needStatesFoodsAvoid: filterAvoid,
                    needStatesFoodsEat: filter,
                  },
                  () => {
                    this.setState({ foodsToggle: "eat" });
                  }
                );
              }

              if (formattedSummaryType === "Products") {
                //if summaryType is Products

                // window.history.pushState(
                //   null,
                //   "",
                //   `/summary/#${this.props?.location?.state?.summaryType?.toLowerCase()}`
                // );

                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Products",
                  page_category: "wellness-products",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.view(updatedObj));
                let filter: any = [];
                data?.products?.forEach((element: any) => {
                  if (
                    element?.productsCompleteData &&
                    _.size(
                      _.filter(
                        element?.productsCompleteData,
                        (item) =>
                          !_.isNil(item?.data) &&
                          item?.data?.name !== "NOT FOUND"
                      )
                    ) > 0
                  ) {
                    filter.push({
                      //displayName: element?.name + " (" + element?.tipsData?.length + ")",
                      displayName:
                        needStateData[element?.name]?.[0] +
                        " (" +
                        +_.size(
                          _.filter(
                            element?.productsCompleteData,
                            (item) =>
                              !_.isNil(item?.data) &&
                              item?.data?.name !== "NOT FOUND"
                          )
                        ) +
                        ")" || "",
                      imgSrc: needStateData[element?.name]?.[3] || "",
                      // displayName:
                      //   formattedText(element?.name) +
                      //   " (" +
                      //   +_.size(
                      //     _.filter(
                      //       element?.productsCompleteData,
                      //       (item) => !_.isNil(item?.data)
                      //     )
                      //   ) +
                      //   ")",
                      name: element?.name || "",
                      isChecked: false,
                    });
                  }
                });
                this.setState({ needStatesProducts: filter });
                let displayedDataArray: any = [];
                data?.products?.forEach((element: any) => {
                  // const products = element?.productsCompleteData;
                  // products && displayedDataArray?.push(...products);
                  const products = element?.productsCompleteData;

                  if (products && products?.length > 0) {
                    const filteredProducts = _.filter(
                      products,
                      (item) =>
                        !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
                    );
                    filteredProducts &&
                      filteredProducts.length > 0 &&
                      displayedDataArray.push(...filteredProducts);
                  }
                });

                this.setState(
                  { displayedDataProducts: displayedDataArray },
                  () => {
                    this.setState({ productsToggle: "on" });
                    let bestIds: any = [];

                    const prods = this.state.data.products;

                    prods?.forEach((element: any) => {
                      bestIds.push(element?.products[0]);
                    });

                    let resultBest = this.state.displayedDataProducts?.filter(
                      (element: any) => {
                        return bestIds?.indexOf(element?.data?.code) !== -1;
                      }
                    );

                    this.setState({ bestProducts: resultBest });
                    let resultOther = this.state.displayedDataProducts?.filter(
                      (element: any) => {
                        return bestIds?.indexOf(element?.data?.code) === -1;
                      }
                    );

                    this.setState({ otherProducts: resultOther });
                  }
                );
              }
            }
          }
        }
      }
    } else {
      this.props.history.push("/results");
    }
  };

  handleClickToggle = (data: any) => {
    if (data === true) {
      this.setState({ productsToggle: "off" });
    }
    if (data === false) {
      this.setState({ productsToggle: "on" });
    }
    // this.setState({ productsToggle: data });
    let bestIds: any = [];
    if (data === "on") {
      const prods = this.state.data.products;
      prods.forEach((element: any) => {
        bestIds.push(element.products[0]);
      });

      let resultBest = this.state.displayedDataProducts?.filter(
        (element: any) => {
          return bestIds?.indexOf(element?.data?.code) !== -1;
        }
      );

      this.setState({ bestProducts: resultBest });
      let resultOther = this.state.displayedDataProducts?.filter(
        (element: any) => {
          return bestIds?.indexOf(element?.data?.code) === -1;
        }
      );

      this.setState({ otherProducts: resultOther });
    }
  };

  handleClickToggleFood = (data: any) => {
    if (data === true) {
      this.setState({ foodsToggle: "eat" });
    }
    if (data === false) {
      this.setState({ foodsToggle: "avoid" });
    }
  };
  handleHeaderSelection = (data: any) => {
    if (data === "Tips") {
      this.props.history.push(`/summary/#tips`, {
        summaryType: "Tips",
        data: this.state.data,
      });
    }
    if (data === "Foods") {
      this.props.history.push(`/summary/#foods`, {
        summaryType: "Foods",
        data: this.state.data,
      });
    }
    if (data === "Products") {
      this.props.history.push(`/summary/#products`, {
        summaryType: "Products",
        data: this.state.data,
      });
    }
    if (data === "Results") {
      this.props.history.push("/results");
    }
  };

  handleCartClick = (e?: any) => {
    this.setState({
      isCartVisible: true,
    });
  };

  handleCartClose = () => {
    this.setState({
      isCartVisible: false,
    });
  };

  getCartProductsList = () => {
    getCartEntries().then((response: any) => {
      let entries: any = [];
      response &&
        response.entries.map((item: any) => {
          entries.push(item);
        });
    });
  };

  handleAddtoCart = (
    productCode: number,
    quantity: number,
    hitStateSubType?: string
  ) => {
    addCartEntries(productCode, quantity).then((response: any) => {
      if (response) {
        //cart addition event

        let authObj = getUtagAuthObject();
        let sessionObj = getUtagSessionObject();
        let needStatesObj = getUtagNeedStates();

        let obj = {
          page_name: "My Products",
          event_name: "cart_addition",
          product_brand: [response?.entry?.product?.brandName],
          ...(response?.entry?.value?.businessVolume && {
            product_businessVolume: [
              response?.entry?.value?.businessVolume?.toString(),
            ],
          }),
          product_id: [response?.entry?.product?.code],
          product_name: [response?.entry?.product?.name],
          ...(response?.entry?.value?.pointValue && {
            product_pointValue: [response?.entry?.value?.pointValue?.toString()],
          }),
          product_referrer: ["wellness-guide"],
          product_unitPrice: [response?.entry?.basePrice?.value?.toString()],
          product_units: [response?.quantityAdded?.toString()],
          wellness_filter: hitStateSubType && hitStateSubType + "-products",
        };
        let updatedObj = _.merge(
          localStorage.getItem("user-info") ? authObj : {},
          localStorage.getObj("reco-result") ? needStatesObj : {},
          sessionObj,
          obj
        );
        withUtag().then((utag) => utag.link(updatedObj));

        this.getCartProductsList();
        this.setState(
          {
            successfullyAdded: true,
          },
          () =>
            setTimeout(() => this.setState({ successfullyAdded: false }), 3000)
        );
      } else {
        this.setState(
          {
            productFailedAddToCart: true,
          },
          () => setTimeout(() => this.setState({ productFailedAddToCart: false }), 3000)
        );
      }
    });
  };

  handleSuccessMsg = () => {
    this.setState(
      {
        successfullyAdded: true,
      },
      () => setTimeout(() => this.setState({ successfullyAdded: false }), 3000)
    );
  };

  handleOutOfStock = () => {
    this.setState(
      {
        displayOutOfStock: true,
      },
      () => setTimeout(() => this.setState({ displayOutOfStock: false }), 3000)
    );
  };

  closePopup = () => {
    this.setState(
      {
        isPopupOpen: false,
      },
      () => {
        sessionStorage.setItem("saveResults", "false");

        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          this.props.history.replace("/home");
          localStorage.setItem("logout", "true");
        }
        // sessionStorage.removeItem("login-session-expired")
      }
    );
  };

  render() {
    const {
      isDetailsVisible,
      selectedType,
      isCartVisible,
      successfullyAdded,
      productsInfo,
      tipsInfo,
      foodsInfo,
      displayOutOfStock,
      visibleOnMobile,
      summaryType,
      productFailedAddToCart,
    } = this.state;
    // const summaryType =
    //   this.props &&
    //   this.props.location &&
    //   this.props.location.state &&
    //   this.props.location.state.summaryType;

    const data =
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.data;

    return window.location.pathname === "/summary/" &&
      (window.location.hash === "#tips" ||
        window.location.hash === "#foods" ||
        window.location.hash === "#products") ? (
      <div className="summary-main-container">
        {/* Details container Start */}
        {isDetailsVisible && (
          <DetailsComponent
            {...this.props}
            handleClose={this.handleDeatilsClose}
            show={isDetailsVisible}
            selectedType={selectedType}
            hitStateData={this.state.hitStateData}
            hitStateIndex={this.state.hitStateIndex}
            hitStateType={this.state.hitStateType}
            hitStateSubType={this.state.hitStateSubType}
            hitStateHeading={this.state.hitStateHeading}
          // handleDetailsCart={(productCode: number, quantity: number) => {
          //   this.handleAddtoCart(productCode, quantity);
          // }}
          />
        )}
        {/* Details container Ends */}

        {/* Save Results Popup Start */}
        {this.state.isSaveResultPopupOpen && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.save_result")}
            popupMessage={this.props.t("common.save_result_message")}
            popupFirstButton={this.props.t("common.sign_in_to_amway")}
            popupFirstButtonType="sign-in"
          />
        )}

        {this.state.isSessionExpired && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.welcome_back")}
            popupMessage={this.props.t("common.login_session_expiry_message")}
            popupFirstButton={this.props.t("common.sign_in")}
            popupFirstButtonType="sign-in"
          // popupSecondButton="Take the Quiz"
          />
        )}
        {/* <SaveResultsPopup
          {...this.props}
          open={this.state.isPopupOpen}
          close={this.closePopup}
          popupTitle={this.props.t("common.save_result")}
          popupMessage={this.props.t("common.save_result_message")}
          popupFirstButton={this.props.t("common.sign_in_to_amway")}
        /> */}

        {/* Save Results Popup Ends */}

        {/* Cart Component Start */}
        {isCartVisible ? (
          <CartComponent
            {...this.props}
            handleClose={this.handleCartClose}
            show={isCartVisible}
          />
        ) : null}
        {/* Cart Component Ends */}

        {/* Add to Cart Success Message Start */}
        {successfullyAdded ? (
          <MessageStrip
            messageText={this.props.t("common.user_added_product_to_cart")}
          />
        ) : null}
        {/* Add to Cart Success Message Ends */}
        {/* Display out of stock Message Start */}
        {displayOutOfStock ? (
          <MessageStrip
            messageText={this.props.t("common.out_of_stock")}
            warning={true}
          />
        ) : null}
        {/* display out of stock Message Ends */}

        {/* Display product fail Message Start */}
        {productFailedAddToCart ? (
          <MessageStrip
            messageText={this.props.t("common.product_failed_add_to_cart")}
            warning={true}
          />        ) : null}
        {/* display out of stock Message Ends */}

        <div className="header-container">
          <ResultsHeader
            {...this.props}
            selectedType={summaryType}
            handleCallBack={(data: any) => this.handleHeaderSelection(data)}
            handleCartClick={this.handleCartClick}
            handleCartKeyPress={(e: any) => {
              if (e.key === "Enter") {
                this.handleCartClick(e);
              }
            }}
          />
        </div>

        {/* middle area start */}
        <div className="middle-area">
          {/* Banner container Start */}
          <div className="banner-container">
            {/* background image Start */}

            {summaryType === "Tips" &&
              tipsInfo &&
              tipsInfo.length > 0 &&
              tipsInfo[0] &&
              tipsInfo[2] &&
              tipsInfo[3] && (
                <div
                  className="image-wrapper"
                  style={{
                    backgroundImage: visibleOnMobile
                      ? `url(${tipsInfo[3]})`
                      : `url(${tipsInfo[2]})`,
                  }}
                >
                  <div className="overlay"></div>
                  <span className="heading">{tipsInfo[0] || ""}</span>
                </div>
              )}

            {summaryType === "Foods" &&
              foodsInfo &&
              foodsInfo.length > 0 &&
              foodsInfo[0] &&
              foodsInfo[2] &&
              foodsInfo[3] && (
                <div
                  className="image-wrapper"
                  style={{
                    backgroundImage: visibleOnMobile
                      ? `url(${foodsInfo[3]})`
                      : `url(${foodsInfo[2]})`,
                  }}
                >
                  <div className="overlay"></div>
                  <span className="heading">{foodsInfo[0] || ""}</span>
                </div>
              )}

            {summaryType === "Products" &&
              productsInfo &&
              productsInfo.length > 0 &&
              productsInfo[0] &&
              productsInfo[2] &&
              productsInfo[3] && (
                <div
                  className="image-wrapper"
                  style={{
                    backgroundImage: visibleOnMobile
                      ? `url(${productsInfo[3]})`
                      : `url(${productsInfo[2]})`,
                  }}
                >
                  <div className="overlay"></div>
                  <span className="heading">{productsInfo[0] || ""}</span>
                </div>
              )}

            {/* background image Ends */}
            {summaryType === "Tips" &&
              tipsInfo &&
              tipsInfo.length > 0 &&
              tipsInfo[1] && (
                <div className="summary-detail">{tipsInfo[1] || ""}</div>
              )}
            {summaryType === "Products" &&
              productsInfo &&
              productsInfo.length > 0 &&
              productsInfo[1] && (
                <div className="summary-detail">{productsInfo[1] || ""}</div>
              )}

            {summaryType === "Foods" &&
              foodsInfo &&
              foodsInfo.length > 0 &&
              foodsInfo[1] && (
                <div className="summary-detail">{foodsInfo[1] || ""}</div>
              )}
          </div>
          {/* Banner container Ends */}

          {/* summary middle area Start */}
          <div className="summary-middle-area">
            <div className="bootstrap-wrapper">
              <div className="inner-wrapper col-md-12 clearfix">
                <div className="left-wrapper col-md-5 col-lg-3 pull-left">
                  <div className="filter-wrapper">
                    <div className="icon filter-icon"></div>
                    <div className="label">
                      {this.props.t("common.filters")}
                    </div>
                  </div>

                  {summaryType && summaryType === "Foods" ? (
                    <ToggleButton
                      {...this.props}
                      handleOnClickToggle2={(selectedValue: any) => {
                        //this.handleClickToggle(one);

                        this.handleClickToggleFood(selectedValue);
                      }}
                      handleOnKyPressToggle2={(selectedValue: any, e: any) => {
                        if (e?.key === "Enter" || e?.key === " ") {
                          this.handleClickToggleFood(selectedValue);
                          //
                        }
                      }}
                      isChecked={false}
                      // handleOnClickToggle={() => {}}
                      lableLeft={this.props.t("common.what_to_eat")}
                      lableRight={this.props.t("common.what_to_avoid")}
                      type1="avoid"
                      type2="eat"
                    />
                  ) : null}

                  {summaryType && summaryType === "Products" ? (
                    <div className="best-for-you-wrapper">
                      <div className="details">
                        <span className="icon star-icon"></span>
                        <span className="label">
                          {this.state?.productsToggle === "on"
                            ? this.props.t("common.your_top_products") +
                            " (" +
                            this?.state?.bestProducts?.length +
                            ")"
                            : this.props.t("common.your_top_products")}
                        </span>
                      </div>
                      <ToggleButton
                        {...this.props}
                        handleOnClickToggle2={(one: any) => {
                          this.handleClickToggle(one);
                        }}
                        isChecked={true}
                        handleOnKyPressToggle2={(one: any, e: any) => {
                          if (e.key === "Enter" || e.key === " ") {
                            this.handleClickToggle(one);
                          }
                        }}
                        type1="off"
                        type2="on"
                        lableLeft=""
                        lableRight=""
                      />
                    </div>
                  ) : null}

                  {summaryType &&
                    summaryType === "Products" &&
                    this.state.needStatesProducts &&
                    this.state.needStatesProducts.length > 0 ? (
                    <div className="wellness-area-wrapper">
                      <div className="label">
                        {this.props.t("common.wellness_areas")}
                      </div>
                      <div className="wellness-area-lists">
                        {this.state?.needStatesProducts?.map((item: any) => (
                          <div className="list" id={item?.name}>
                            <span
                              className="icon filter-icon"
                              style={{
                                backgroundImage: item
                                  ? `url(${item?.imgSrc})`
                                  : ``,
                              }}
                            //className="icon"
                            ></span>
                            {/* <span className="icon filter-icon"></span> */}
                            <span className="list-label">
                              {item?.displayName}
                            </span>
                            <CheckBox
                              className={"checkbox"}
                              onCheckboxClick={(evt) =>
                                this.handleCheckboxClick(evt, item?.name)
                              }
                            // isChecked={item && item.isChecked}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}
                  {summaryType &&
                    summaryType === "Tips" &&
                    this.state.needStatesTips &&
                    this.state.needStatesTips.length > 0 ? (
                    <div className="wellness-area-wrapper">
                      <div className="label">
                        {this.props.t("common.wellness_areas")}
                      </div>
                      <div className="wellness-area-lists">
                        {this.state?.needStatesTips?.map((item: any) => (
                          <div className="list" id={item?.name}>
                            <span
                              className="icon filter-icon"
                              style={{
                                backgroundImage: item
                                  ? `url(${item?.imgSrc})`
                                  : ``,
                              }}
                            //className="icon"
                            ></span>
                            <span className="list-label">
                              {item?.displayName}
                            </span>
                            <CheckBox
                              className={"checkbox"}
                              onCheckboxClick={(evt) =>
                                this.handleCheckboxClick(evt, item?.name)
                              }
                            //isChecked={item && item.isChecked}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {summaryType &&
                    summaryType === "Foods" &&
                    this.state.needStatesFoodsEat &&
                    this.state.needStatesFoodsEat.length > 0 &&
                    this.state.foodsToggle === "eat" ? (
                    <div className="wellness-area-wrapper">
                      <div className="label">
                        {this.props.t("common.wellness_areas")}
                      </div>
                      <div className="wellness-area-lists">
                        {this.state?.needStatesFoodsEat?.map((item: any) => (
                          <div className="list" id={item?.name}>
                            <span
                              className="icon filter-icon"
                              style={{
                                backgroundImage: item
                                  ? `url(${item.imgSrc})`
                                  : ``,
                              }}
                            //className="icon"
                            ></span>
                            {/* <span className="icon filter-icon"></span> */}
                            <span className="list-label">
                              {item?.displayName}
                            </span>
                            <CheckBox
                              className={"checkbox"}
                              onCheckboxClick={(evt) =>
                                this.handleCheckboxClick(evt, item?.name)
                              }
                              isChecked={item && item.isChecked}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {summaryType &&
                    summaryType === "Foods" &&
                    this.state.needStatesFoodsAvoid &&
                    this.state.needStatesFoodsAvoid.length > 0 &&
                    this.state.foodsToggle === "avoid" ? (
                    <div className="wellness-area-wrapper">
                      <div className="label">
                        {this.props.t("common.wellness_areas")}
                      </div>
                      <div className="wellness-area-lists">
                        {this.state?.needStatesFoodsAvoid?.map((item: any) => (
                          <div className="list" id={item?.name}>
                            <span
                              className="icon filter-icon"
                              style={{
                                backgroundImage: item
                                  ? `url(${item.imgSrc})`
                                  : ``,
                              }}
                            //className="icon"
                            ></span>
                            {/* <span className="icon filter-icon"></span> */}
                            <span className="list-label">
                              {item?.displayName}
                            </span>
                            <CheckBox
                              className={"checkbox"}
                              onCheckboxClick={(evt) =>
                                this.handleCheckboxClick(evt, item?.name)
                              }
                              isChecked={item && item.isChecked}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="right-wrapper col-md-7 col-lg-9 pull-right">
                  {summaryType === "Tips" &&
                    this.state?.displayedData?.length > 0 && (
                      <div className="all-food-wrapper">
                        <div className="label">
                          {this.props.t("common.all_tips")}{" "}
                          {`(${this.state?.displayedData?.length}) `}
                        </div>
                      </div>
                    )}

                  {summaryType === "Products" &&
                    this.state.productsToggle === "off" &&
                    this.state?.displayedDataProducts?.length > 0 && (
                      <div className="all-food-wrapper">
                        <div className="label">
                          {this.props.t("common.all_products")}{" "}
                          {`(${this.state?.displayedDataProducts?.length}) `}
                        </div>
                      </div>
                    )}

                  {summaryType === "Foods" &&
                    this.state.foodsToggle === "eat" &&
                    this.state?.displayedDataFoodsEat?.length > 0 && (
                      <div className="all-food-wrapper">
                        <div className="label">
                          {this.props.t("common.all_foods_to_eat")}
                          {` (${this.state?.displayedDataFoodsEat?.length}) `}
                        </div>
                      </div>
                    )}

                  {summaryType === "Foods" &&
                    this.state.foodsToggle === "avoid" &&
                    this.state?.displayedDataFoodsAvoid?.length > 0 && (
                      <div className="all-food-wrapper">
                        <div className="label">
                          {this.props.t("common.all_foods_to_skip")}
                          {` (${this.state?.displayedDataFoodsAvoid?.length}) `}
                        </div>
                      </div>
                    )}

                  {this.state.productsToggle === "on" &&
                    summaryType === "Products" &&
                    this.state?.bestProducts?.length > 0 && (
                      <div className="all-food-wrapper">
                        {/* <div className="label">All Foods to Eat (18)</div> */}
                        <div className="label">
                          {summaryType &&
                            this.props.t("common.your_top_products") +
                            " (" +
                            this.state?.bestProducts?.length +
                            ")"}
                        </div>
                      </div>
                    )}
                  {/* Food Summary Start */}
                  {summaryType &&
                    summaryType === "Foods" &&
                    this.state.foodsToggle === "eat" && (
                      <FoodComponent
                        {...this.props}
                        foodSubType="eat"
                        colClassName="col-md-12 col-lg-4"
                        handleSeeMore={(index: number, heading: string) =>
                          this.handleSeeMore("food", index, "eat", heading)
                        }
                        foodsData={this.state?.displayedDataFoodsEat}
                        handleSeeMoreOnKeyPress={(
                          index: number,
                          heading: string,
                          e: any
                        ) => {
                          if (e.key === "Enter") {
                            this.handleSeeMore("food", index, "eat", heading);
                          }
                        }}
                      />
                    )}

                  {summaryType &&
                    summaryType === "Foods" &&
                    this.state.foodsToggle === "avoid" && (
                      <FoodComponent
                        {...this.props}
                        foodSubType="avoid"
                        colClassName="col-md-12 col-lg-4"
                        handleSeeMore={(index: number, heading: string) =>
                          this.handleSeeMore("food", index, "avoid", heading)
                        }
                        handleSeeMoreOnKeyPress={(
                          index: number,
                          heading: string,
                          e: any
                        ) => {
                          if (e?.key === "Enter") {
                            this.handleSeeMore(
                              "food",
                              index,
                              "avoid",
                              heading,
                              e
                            );
                          }
                        }}
                        foodsData={this.state?.displayedDataFoodsAvoid}
                      />
                    )}
                  {/* Food Summary Ends */}

                  {/* Tips Summary Start */}
                  {summaryType &&
                    summaryType === "Tips" &&
                    this.state.displayedData &&
                    this.state.displayedData.length > 0 && (
                      // this.state.data?.needStateImages &&
                      // this.state.data?.needStateImages.length > 0 && (
                      <TipsComponent
                        {...this.props}
                        colClassName="col-md-12 col-lg-4"
                        tipsData={this.state.displayedData}
                        handleSeeMore={(index: number, heading: string) =>
                          this.handleSeeMore("tips", index, "", heading)
                        }
                        handleSeeMoreOnKeyPress={(
                          index: number,
                          heading: string,
                          e: any
                        ) => {
                          if (e.key === "Enter" || e.key === " ") {
                            this.handleSeeMore("tips", index, " ", heading, e);
                          }
                        }}
                      />
                    )}
                  {/* Tips Summary Ends */}

                  {/* Product Summary Start */}
                  {summaryType &&
                    summaryType === "Products" &&
                    (this.state.productsToggle === "on" ? (
                      <>
                        <ProductComponent
                          {...this.props}
                          subType="best"
                          colClassName="col-md-12 col-lg-6"
                          productsData={this.state.bestProducts}
                          needStateImages={this.state?.data?.needStateImages}
                          handleLearnMore={(index: number) =>
                            this.handleSeeMore("product", index, "best")
                          }
                          handleAddtoCart={(
                            productCode: number,
                            quantity: number
                          ) =>
                            this.handleAddtoCart(productCode, quantity, "best")
                          }
                          handleOutOfStock={this.handleOutOfStock}
                          handleSuccessMsg={this.handleSuccessMsg}
                        />
                        {/* <div>other products</div> */}
                        {this.state.otherProducts &&
                          this.state.otherProducts.length > 0 && (
                            <>
                              <div className="all-food-wrapper">
                                {/* <div className="label">All Foods to Eat (18)</div> */}

                                <div className="label">
                                  {this.props.t("common.other_products") +
                                    " (" +
                                    this.state?.otherProducts?.length +
                                    ")"}
                                </div>
                              </div>
                              <ProductComponent
                                {...this.props}
                                subType="other"
                                colClassName="col-md-12 col-lg-4"
                                productsData={this.state.otherProducts}
                                needStateImages={
                                  this.state?.data?.needStateImages
                                }
                                handleLearnMore={(index: number) =>
                                  this.handleSeeMore("product", index, "other")
                                }
                                handleAddtoCart={(
                                  productCode: number,
                                  quantity: number
                                ) =>
                                  this.handleAddtoCart(
                                    productCode,
                                    quantity,
                                    "other"
                                  )
                                }
                                handleOutOfStock={this.handleOutOfStock}
                                handleSuccessMsg={this.handleSuccessMsg}
                              />
                            </>
                          )}
                      </>
                    ) : (
                      this.state.displayedDataProducts &&
                      this.state.displayedDataProducts.length > 0 && (
                        <ProductComponent
                          {...this.props}
                          subType="all"
                          colClassName="col-md-12 col-lg-4"
                          productsData={this.state.displayedDataProducts}
                          needStateImages={this.state?.data?.needStateImages}
                          handleLearnMore={(index: number) =>
                            this.handleSeeMore("product", index, "all")
                          }
                          handleAddtoCart={(
                            productCode: number,
                            quantity: number
                          ) =>
                            this.handleAddtoCart(productCode, quantity, "all")
                          }
                          handleOutOfStock={this.handleOutOfStock}
                          handleSuccessMsg={this.handleSuccessMsg}
                        />
                      )
                    ))}
                  {/* Product Summary Ends */}
                </div>
              </div>
            </div>
          </div>
          {/* summary middle area Ends */}
        </div>
        {/* middle area Ends */}

        {/* Footer Section Start */}
        <Footer {...this.props} />
        {/* Footer Section Ends */}
      </div>
    ) : (
      <PageNotFound {...this.props} />
    );
  }
}

export default withOktaAuth(SummaryComponent);
